import { ComponentSettingsClient } from './types';

export const defaultSettings: ComponentSettingsClient = {
  componentsAllocation: {
    allocationFlow: 'modal',
  },
  subscription: {
    details: 'page',
  },
  paymentProfile: {
    editFlow: 'modal',
    requiredFields: [],
    addressFields: ['address', 'address2', 'city', 'state', 'zip', 'country'],
  },
};
